const faqs = [
  {
    q: '今日看料官网的官方入口是什么？',
    a: '今日看料官方网站通过本页面提供最新官方地址导航，您可将本站添加至书签，方便随时通过安全入口访问品牌首页。本站持续维护并更新入口信息，确保导航始终有效。',
  },
  {
    q: '如何使用今日看料首页进行内容浏览？',
    a: '进入今日看料首页后，您可通过顶部的主题导航栏快速定位感兴趣的内容频道，也可在热度榜单中发现当前最受欢迎的内容方向。首页各模块均支持一键跳转至对应的内容合集页面。',
  },
  {
    q: '今日看料的最新地址在哪里可以获取？',
    a: '本站作为今日看料的官方首页导航站点，会第一时间同步最新的官方地址。建议您收藏本页面（jinrikankan.com），这是获取最新地址最可靠的途径，也可关注本站的更新动态模块了解地址变更通知。',
  },
  {
    q: '今日看料平台是否免费使用？',
    a: '今日看料作为内容聚合导航平台，首页提供的全部导航服务和内容索引均免费向用户开放。您无需注册即可浏览平台上的各类内容推荐与频道入口。',
  },
  {
    q: '移动端如何访问今日看料？',
    a: '今日看料支持手机浏览器直接访问，页面已针对移动端进行自适应优化。您也可在移动端入口模块获取更多移动端使用建议，体验与桌面端一致的高品质内容导航服务。',
  },
  {
    q: '平台上内容多久更新一次？',
    a: '今日看料首页的内容推荐与话题榜单每日定时更新，编辑团队持续筛选最新、最热门的优质内容。精选视频、热点话题等模块保持高频更新节奏，确保您每次访问都有新鲜发现。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于今日看料平台，你可能想了解的内容
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200"
            >
              <h3 className="text-base md:text-lg font-bold text-foreground-900 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-xl mt-0.5 shrink-0">Q</span>
                {faq.q}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}